<div class="warehouse-dropdown">
  <ul class="m-0 p-0">
    @for (item of warehouses; track item; let i = $index) {
      <li
        (click)="onItemSelected(item.id || item.value); onClick.emit(item)"
        (keyup.enter)="onItemSelected(item.id || item.value); onClick.emit(item)"
        class="d-flex align-items-center spacing-8 justify-content-between warehouse-list cursor-pointer"
        tabindex="0">
        <div class="d-flex align-items-center spacing-8">
          <app-icon-container
            [Type]="'icon'"
            [Size]="'large'"
            [IconType]="'warehouse'"
            [background_color]="'primary-80'"></app-icon-container>
          <div class="h3-bold primary-100 d-flex flex-column align-items-start spacing-4">
            {{ item.label }}
            <span class="h4-reg primary-60">{{ item.tagLine }}</span>
          </div>
        </div>
        @if (item.status) {
          <app-badges
            [withIcon]="true"
            [Type]="item.status.Type"
            [counter]="false"
            [divideText]="'Order no.'"
            [dividedText]="false"
            [close]="false"
            [onlyIcon]="false"
            [label]="item.status.label"
            [ellipsis]="true"></app-badges>
        }
      </li>
    }
  </ul>
</div>
